/* GP digital finder + console lookup: lazy Shopify product fetch after customer choice */
(function(){
 'use strict';
 const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
 const origin=(window.Shopify?.routes?.root)||'/';
 function clear(el){el?.replaceChildren()}
 function textNode(tag,txt,cls){const el=document.createElement(tag);el.textContent=txt;if(cls)el.className=cls;return el}
 function a(label,url){const x=document.createElement('a');x.textContent=label;x.href=url;return x}
 function safePrice(value){return 'BHD '+(Number(value)/100).toFixed(3)}
 function regionFromTitle(input){
  const t=String(input||'').toUpperCase();
  const regions=[['US',/\bUSA\b|\bUS\b|UNITED STATES|\bUSD\b/],['UK',/\bUK\b|UNITED KINGDOM|\bGBP\b/],['BH',/BAHRAIN|\bBHD\b/],['AE',/\bUAE\b|\bAED\b|DUBAI/],['SA',/SAUDI|\bKSA\b|\bSAR\b/],['KW',/KUWAIT|\bKWD\b/],['QA',/QATAR|\bQAR\b/],['OM',/OMAN|\bOMR\b/],['GLOBAL',/\bGLOBAL\b|WORLDWIDE/]];
  let matches=regions.filter(([n,regex])=>regex.test(t)).map(([n])=>n);
  if(matches.length>1&&matches.includes('BH')&&/(?:\|\s*BAHRAIN\s*$|[-–]\s*BAHRAIN\s*$|DELIVERY[-\s]*BAHRAIN)/.test(t)){
    // A store-location/delivery suffix is not a redemption region.
    matches=matches.filter(x=>x!=='BH');
  }
  return matches.length===1?matches[0]:null;
 }
 async function collectionProducts(handle){
  const response=await fetch(origin+'collections/'+encodeURIComponent(handle)+'/products.json?limit=250',{headers:{Accept:'application/json'}});
  if(!response.ok)throw Error('Catalog is unavailable');
  const data=await response.json();return data.products||[];
 }
 function initGift(){
  const el=$('[data-gp-gift-finder]');if(!el)return;
  const platform=$('[data-gp-gift-platform]',el),region=$('[data-gp-gift-region]',el),max=$('[data-gp-gift-max]',el),status=$('[data-gp-gift-status]',el),results=$('[data-gp-gift-results]',el),button=$('[data-gp-gift-find]',el);
  let currentAbort=0;
  const preferenceKey='gp_gift_finder_preferences_v1';
  try{const saved=JSON.parse(localStorage.getItem(preferenceKey)||'null');if(saved){
    if([...platform.options].some(o=>o.value===saved.platform))platform.value=saved.platform;
    if([...region.options].some(o=>o.value===saved.region))region.value=saved.region;
    if([...max.options].some(o=>o.value===saved.max))max.value=saved.max;
  }}catch(e){}
  const remember=()=>{try{localStorage.setItem(preferenceKey,JSON.stringify({platform:platform.value,region:region.value,max:max.value}))}catch(e){}};
  [platform,region,max].forEach(control=>control.addEventListener('change',remember));
  const finder=async()=>{
   const h=platform.value,selectedRegion=region.value,cap=Number(max.value||0);clear(results);
   if(!h){status.textContent='Choose a platform first.';platform.focus();return}
   const ticket=++currentAbort;button.disabled=true;status.textContent='Checking available catalog listings…';
   try{
    const all=await collectionProducts(h);if(ticket!==currentAbort)return;
    const available=all.filter(p=>p.variants?.some(v=>v.available===true));
    const candidates=available.filter(p=>{
     const options=(p.variants||[]).filter(x=>x.available===true);
     const low=Math.min(...options.map(v=>Number(v.price||0)/100));
     if(cap&&low>cap)return false;
     const known=regionFromTitle(p.title);
     // Region-constrained searches only show explicitly labelled matching listings.
     return !selectedRegion||known===selectedRegion;
    }).slice(0,12);
    status.textContent=candidates.length?candidates.length+' matching listing(s) shown. Check denomination and account-region details before payment.':'No clearly region-labelled matches were found. Browse the platform collection or ask our team to confirm eligibility.';
    for(const p of candidates){
     const card=textNode('article','','gp-next-result-card');
     const link=a(p.title,origin+'products/'+p.handle);
     if(p.images?.[0]?.src){const img=document.createElement('img');img.loading='lazy';img.src=p.images[0].src;img.alt='';card.append(img)}
     card.append(link);
     const availableVariants=(p.variants||[]).filter(v=>v.available);
     const min=Math.min(...availableVariants.map(v=>Number(v.price)));
     const vr=availableVariants.find(v=>Number(v.price)===min)||availableVariants[0];
     card.append(textNode('small','From '+safePrice(vr?.price||0)));
     if(availableVariants.length>1){
       const choices=textNode('div','','gp-next-variants');
       availableVariants.slice(0,5).forEach(v=>{
         const label=String(v.title||'').trim()||'Select option';
         const option=a(label+' · '+safePrice(v.price),origin+'products/'+p.handle+'?variant='+encodeURIComponent(v.id));
         option.setAttribute('aria-label','Review '+label+' variant and terms on product page');
         choices.append(option);
       });
       card.append(choices);
     }
     card.append(textNode('small','Redemption region: '+(regionFromTitle(p.title)||'Not independently verified')));
     if(!regionFromTitle(p.title))card.append(textNode('em','Verify region before purchase'));
     const btn=a('Choose denomination / View →',link.href);card.append(btn);results.append(card);
    }
    if(!candidates.length)results.append(a('Browse all '+platform.selectedOptions[0].textContent+' cards →',origin+'collections/'+h));
   }catch(e){if(ticket===currentAbort)status.textContent='Could not load gift cards. Use the platform collection link or contact support.'}
   finally{if(ticket===currentAbort)button.disabled=false}
  };
  button.addEventListener('click',finder);
  platform.addEventListener('change',()=>{clear(results);status.textContent='';if(platform.value==='playstation-gift-cards'&&region.value==='BH'){status.textContent='For Bahrain PSN, look under the dedicated Bahrain collection if the broader collection has no exact match.'}});
 }
 function initConsole(){
  const el=$('[data-gp-console-finder]');if(!el)return;
  const where=$('[data-gp-console-content]',el);
  const modelOptions={
   ps:[['PS5 / PS5 Slim','ps5'],['PS4','ps4']],
   xbox:[['Xbox Series X / Series S','xboxseries'],['Xbox One','xboxone']],
   nintendo:[['Nintendo Switch','switch'],['Nintendo Switch OLED','switcholed'],['Nintendo Switch Lite','switchlite']],
   retro:[['Retro handheld (confirm model)','retro']]
  };
  const data={
   ps:{name:'PlayStation',links:[['Consoles','/collections/consoles'],['Controllers','/collections/controllers'],['PlayStation cards','/collections/playstation-gift-cards'],['Racing accessories','/collections/racing-wheel-flight-simulator']]},
   xbox:{name:'Xbox',links:[['Consoles','/collections/consoles'],['Controllers','/collections/controllers'],['Xbox cards and subscriptions','/collections/xbox-live'],['Gaming headsets','/collections/headset-1']]},
   nintendo:{name:'Nintendo Switch',links:[['Switch consoles','/collections/nintendo-switch-consoles'],['Nintendo cases','/collections/nintendo-case'],['eShop','/collections/nintendo-eshop'],['Controllers','/collections/controllers']]},
   retro:{name:'Retro and handheld',links:[['Handheld consoles','/collections/retro-handheld-consoles'],['All consoles','/collections/consoles'],['Cables','/collections/cable'],['Controllers','/collections/controllers']]}
  };
  const model=el.querySelector('[data-gp-console-model]'),show=el.querySelector('[data-gp-console-match]');
  let family='';
  function compatibility(title,code){
   const s=String(title||'').toLowerCase();
   if(code==='ps5')return /\bps5\b|playstation\s*5|dualsense/.test(s);
   if(code==='ps4')return /\bps4\b|playstation\s*4|dualshock\s*4/.test(s);
   if(code==='xboxseries')return /xbox\s*series\s*[xs]|xbox\s*wireless\s*controller/.test(s);
   if(code==='xboxone')return /xbox\s*one/.test(s);
   if(code==='switcholed')return /switch\s*oled/.test(s);
   if(code==='switchlite')return /switch\s*lite/.test(s);
   if(code==='switch')return /nintendo\s*switch|\bswitch\b/.test(s)&&!/switch\s*lite|switch\s*oled/.test(s);
   return false;
  }
  $$('[data-gp-console]',el).forEach(b=>b.addEventListener('click',()=>{
   $$('[data-gp-console]',el).forEach(x=>x.setAttribute('aria-pressed',String(x===b)));
   family=b.dataset.gpConsole;
   const c=data[family];if(!c)return;
   clear(where);clear(show);where.append(textNode('p','Browse '+c.name+' items. Compatibility depends on the exact model, controller generation, port and region.'));
   const links=textNode('div','','gp-next-console__content-links');
   for(const [name,url] of c.links)links.append(a(name+' →',url));
   where.append(links);
   const support=a('Ask about repairs, bundles, upgrades or compatibility','https://wa.me/97336820393?text='+encodeURIComponent('Hello Gamers Point, please help me with '+c.name+' consoles, compatible accessories, bundle and available support services.'));
   support.target='_blank';support.rel='noopener';where.append(textNode('p',''),support);
   model.replaceChildren();
   const blank=document.createElement('option');blank.value='';blank.textContent='Choose your exact model';model.append(blank);
   for(const [label,value] of modelOptions[family]||[]){const opt=document.createElement('option');opt.value=value;opt.textContent=label;model.append(opt)}
  }));
  el.querySelector('[data-gp-console-accessories]')?.addEventListener('click',async()=>{
   clear(show);
   if(!model.value||!family){show.append(textNode('p','Select your console family and model first.'));return}
   if(model.value==='retro'){show.append(textNode('p','Retro handheld models use different connectors and accessories. Send your exact model to Gamers Point for checking.'));return}
   show.append(textNode('p','Finding model-labelled accessory listings…'));
   const groups=family==='nintendo'?['controllers','nintendo-case']:['controllers','headset-1'];
   try{
    const products=(await Promise.all(groups.map(handle=>collectionProducts(handle)))).flat();
    const found=[...new Map(products.filter(p=>p.variants?.some(v=>v.available)&&compatibility(p.title,model.value)).map(p=>[p.handle,p])).values()].slice(0,8);
    clear(show);
    if(!found.length){show.append(textNode('p','No accessories with a clearly matching model name were found. Please confirm availability and compatibility with our team.'));return}
    show.append(textNode('p','These product titles mention your selected model family; connector, console revision and region suitability still need checking.'));
    const grid=textNode('div','','gp-next-console__matched-grid');
    for(const product of found){
     const card=textNode('div','','gp-next-result-card');
     const link=a(product.title,origin+'products/'+product.handle);card.append(link);
     card.append(textNode('small','Model mentioned in product title; confirm exact fit before ordering.'));
     grid.append(card);
    }
    show.append(grid);
    const ask=a('Request a console + accessories bundle quotation','https://wa.me/97336820393?text='+encodeURIComponent('Hello Gamers Point, I want a console/accessories bundle quotation for '+model.selectedOptions[0].textContent+'. Please confirm compatible products, availability and total price.'));
    ask.target='_blank';ask.rel='noopener';show.append(ask);
   }catch(e){clear(show);show.append(textNode('p','Accessory lookup is temporarily unavailable. Please browse the categories or contact support.'))}
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{initGift();initConsole()});else{initGift();initConsole()}
})();